import React, { useState, useEffect } from 'react'
import CKEditor from 'ckeditor4-react'
import { Row } from 'rsuite'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ShowLimitLength from '../../utils/ShowLimitLength'
import './styles.less'

export default function CKEditorBlankFrom({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onChange = () => {},
  notValidate,
  noControlLabel,
  marginTopRow = 10,
  ...props
}) {
  const keyName = props.name || schema.name
  const dfValue = props.value || schema.value
  const maxLength = props.maxLength || getMaxLengthData(schema.validators)?.value
  const [textLength, setTextLength] = useState(dfValue ? dfValue.length : 0)
  const [validators, setValidators] = useState(schema.validators)
  const disableInput = props?.disable || false
  // const isRequired = props.required ? props.required : false

  // console.log('ddddd ', disableInput, schema)

  useEffect(() => {
    countText(dfValue)
  }, [dfValue])

  const onEditorChange = (evt) => {
    const data = evt.editor.getData()
    const text = evt.editor.document.getBody().getText()
    // console.log('texxxxx ', text)
    if (data.length > 0) {
      console.log('a')
      setValue(keyName, data)
      clearErrors(keyName)
      // setTextLength(text.length)
      countText(text)
    } else {
      console.log('b')
      setValue(keyName)
      setTextLength(0)
    }
    onChange(data)
  }

  // ## ใช้สำหรับแก้ไขเรื่องบันทึกตัวอักษรที่ติด html tag
  const countText = (str) => {
    const round0 = str?.replaceAll('&nbsp;', ' ')
    const round1 = round0?.replaceAll('<p>', '')
    const round2 = round1?.replaceAll('</p>', '')
    const round3 = round2?.replaceAll('\n', '')

    setTextLength(round3?.length || 0)

    if (schema?.validators?.length > 0) {
      // if (round3?.length >= maxLength && round3?.length <= maxLength) {
      if (round3?.length <= maxLength) {
        const valid = [schema.validators[0]] || []
        setValidators(valid)
      } else {
        setValidators(schema.validators)
      }
    }
  }

  //ทำไว้ใช้งานเฉพาะรายงานความก้าวหน้าโครงการย่อย
  if (disableInput) {
    return (
      <>
        <Row style={{ marginTop: marginTopRow, backgroundColor: '#F8F8F9' }}>
          <div
            style={{
              padding: 8,
              wordBreak: 'break-word',
              height: 152,
              overflow: 'auto',
              cursor: 'not-allowed',
              color: '#000000',
            }}
            dangerouslySetInnerHTML={{ __html: props.value || schema.value || '' }}
          />
        </Row>
      </>
    )
  }

  return (
    <>
      {schema && (
        <>
          <Row style={{ marginTop: marginTopRow }}>
            <ErrorMessage error={errors[keyName]} style={{ marginBottom: 10 }} />
            {schema.label && !noControlLabel && (
              <p>{requiredFiled(schema.validators, schema.label)}</p>
            )}
            {schema.description && <CustomIconMessageInfo contents={schema.description} />}
            <div className="custom-ckeditor">
              <Controller
                key={keyName}
                name={keyName}
                control={control}
                // rules={isValidators(schema.validators)}
                rules={notValidate ? false : isValidators(validators)}
                defaultValue={dfValue}
                render={(props) => {
                  // enterMode
                  return (
                    <CKEditor
                      data={props.value}
                      // config={{
                      // fontSize_sizes: '16/16px;24/24px;48/48px;',
                      // coreStyles_italic: {
                      //   element: 'span',
                      //   attributes: { class: 'Italic' },
                      // },
                      // fontSize_defaultLabel: '46px',
                      // font_names: 'Sarabun',
                      // font_style: {
                      //   element: 'p',
                      //   styles: { 'font-family': 'Sarabun, sans-serif' },
                      //   overrides: [{ element: 'font', attributes: { face: null } }],
                      // },
                      // }}
                      config={{
                        versionCheck: false,
                        // readOnly: true,
                        autoParagraph: false, // เพิ่มขึ้นมาเพื่อลบ tag <p> ออกทำให้บันทึกตัวอักษรได้เต็มจำนวน
                        editorplaceholder: schema.label,
                        placeholder: schema.label,
                        toolbar: [],
                        readOnly: disableInput,
                        contentsCss: [
                          'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                          'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                        ],
                      }}
                      onChange={onEditorChange}
                    />
                  )
                }}
              />
            </div>
          </Row>
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </>
      )}
    </>
  )
}
